'use strict';

angular.module('shiftTraderApp')
    .controller('CreateTemplatesDialogCtrl', function ($scope, $uibModalInstance, Session, ShiftTemplates, params, toastr) {
      $scope.me = params.me;
      $scope.allShiftTemplates = params.allShiftTemplates;
      $scope.workPeriodsByPositionId = params.workPeriodsByPositionId;
      $scope.org = params.org;
      $scope.templateFormData = {
        name: '',
        desc: ''
      };

      $scope.close = function() {
        $uibModalInstance.close($scope.allShiftTemplates);
      };

      $scope.anyWorkPeriods = _.any($scope.workPeriodsByPositionId, function(x) {
        return x.length > 0;
      });

      $scope.createTemplate = function() {
        if ($scope.templateFormData.name !== '' && $scope.templateFormData.name.length >= 1) {
          var workPeriodIds = [];
          _.each($scope.allDepartments, function(dept) {
            _.each(dept.positions, function(pos) {
              if (pos._selected) {
                workPeriodIds.push.apply(workPeriodIds, _.pluck($scope.workPeriodsByPositionId[pos.id], 'id'));
              }
            });
          });

          var data = {
            organization_id: Session.getCurrentOrgId(),
            name: $scope.templateFormData.name,
            description: $scope.templateFormData.desc,
            work_period_ids: workPeriodIds.join(',')
          };

          ShiftTemplates.create(data)
              .then(function(resp) {
                $scope.allShiftTemplates.push(resp);
                toastr.success('Shift template ' + resp.name + ' created.', 'Success');
                $uibModalInstance.close($scope.allShiftTemplates);
              }, function() {
                toastr.error('Error creating shift template', 'Error');
              });

        } else {
          toastr.error('Please set a name for your template.', 'Error');
        }

      };


      $scope.allDepartments = _.map(_.cloneDeep($scope.org.departments), function(dept) {
        var numWorkPeriodsToBePublishedInDepartment = 0;
        dept._selected = false;
        dept.positions = _.map(dept.positions, function(pos) {
          pos._numWorkPeriodsToBePublished = $scope.workPeriodsByPositionId[pos.id].length;
          numWorkPeriodsToBePublishedInDepartment += pos._numWorkPeriodsToBePublished;
          return pos;
        });
        dept._numWorkPeriodsToBePublished = numWorkPeriodsToBePublishedInDepartment;
        return dept;
      });

      $scope.selectAllPositionsInDept = function(dept) {
        _.each(dept.positions, function(pos) {
          if (pos._numWorkPeriodsToBePublished > 0) {
            pos._selected = true;
          }
        });

        dept._anySelected = true;
        dept._allSelected = true;
      };

      $scope.deselectAllPositionsInDept = function(dept) {
        _.each(dept.positions, function(pos) {
          pos._selected = false;
        });

        dept._anySelected = false;
        dept._allSelected = false;
      };

      $scope.togglePositionSelection = function(pos) {
        pos._selected = !pos._selected;

        var idx = _.findIndex($scope.allDepartments, {id: pos.department_id});
        $scope.allDepartments[idx]._anySelected = _.any($scope.allDepartments[idx].positions, function(pos) {
          return pos._selected && pos._numWorkPeriodsToBePublished > 0;
        });

        $scope.allDepartments[idx]._allSelected = _.all($scope.allDepartments[idx].positions, function(pos) {
          return pos._selected || pos._numWorkPeriodsToBePublished === 0;
        });
      };

      $scope.countSelectedWorkPeriods = function(dept) {
        return _.reduce(_.map(dept.positions, function(pos) {
          if (pos._selected) {
            return pos._numWorkPeriodsToBePublished;
          } else {
            return 0;
          }
        }), function(x,y) {
          return x + y;
        });
      };

      $scope.isSomethingSelected = function() {
        return _.any(_.map($scope.allDepartments, function(dept) {
          return _.any(dept.positions, function(pos) {
            return pos._selected;
          });
        }));
      };

    });
